<template>
  <main class="main main--not-found">
    <div class="group">
      <h1 class="h1 mb0">Uh oh!</h1>
      <p class="large">Page not found…</p>
      <module-button
        :link="isAuthenticated ? `dashboard` : `home`"
        button="primary"
        :label="`Back ${isAuthenticated ? `to your dashboard` : `home`}`"
      />
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Services
import { createMeta } from 'services/meta';

// Models
import meta from 'models/meta';

// Modules
import ModuleButton from 'modules/Button';

// Export
export default {
  name: `view-not-found`,

  // Meta data
  metaInfo: {
    title: meta.notFound.title,
    meta: createMeta(meta.notFound.meta),
  },

  // Components
  components: {
    ModuleButton,
  },

  // Data
  computed: {
    ...mapGetters(`auth`, [
      `isAuthenticated`,
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// 404.vue?09639098